var enableRuntimeBranding = function (brandingObj, runtimeBranding) {
    var brandingObjValue = brandingObj;
    var runtimeBrandingObj = runtimeBranding;
    if (runtimeBrandingObj && runtimeBrandingObj !== null) {
        var brandingObjKeys = Object.keys(brandingObjValue);
        var runtimeBrandingObjKeys_1 = Object.keys(runtimeBrandingObj);
        brandingObjKeys.forEach(function (item) {
            if (runtimeBrandingObjKeys_1.includes(item)) {
                brandingObjValue.item = runtimeBrandingObj.item;
            }
            return brandingObjValue.item;
        });
    }
    return brandingObjValue;
};
export default enableRuntimeBranding;
